// extracted by mini-css-extract-plugin
module.exports = {"opcao":"Opcao_opcao__1TRzm","icone":"Opcao_icone__3-U3P","descricao":"Opcao_descricao__1GwWJ","selecionar":"Opcao_selecionar__2Agrc"};